<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.bonus-forecast') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.bonus-forecast') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <el-tooltip :content="$t('dashboard.export')" placement="top">
                  <el-button type="text" class="el-icon-download" @click="exportExcel"></el-button>
                </el-tooltip>
              </div>
              <h4>
                <el-date-picker
                    v-model="dateRange"
                    slot="prepend"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('contract.to')"
                    :start-placeholder="$t('contract.start-date')"
                    :end-placeholder="$t('contract.end-date')"
                    @change="filterList"
                    >
                  </el-date-picker>
              </h4>
            </div>
            <div class="card-body">
              <el-table
                id="bonus-forecast"
                ref="b-f"
                :data="bonus"
                style="width: 100%"
                :summary-method="getSummaries"
              show-summary
                >
                <el-table-column
                  prop="name"
                  :label="$t('bonus.name')"
                  sortable
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="team"
                  :label="$t('bonus.team')"
                  width="120"
                  sortable
                  :filters="teamFilter"
                        :filter-method="filterHandler">
                  <template slot-scope="scope">
                    {{ getTeam(scope.row.team) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quota"
                  :label="$t('bonus.quota')"
                  sortable
                  width="150">
                  <template slot-scope="scope">
                    {{ scope.row.quota | roundNum }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="salary"
                  :label="$t('bonus.salary')"
                  sortable
                  width="120">
                  <template slot-scope="scope">
                    {{ scope.row.salary | roundNum }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="cashin"
                  :label="$t('bonus.cashin')"
                  sortable
                  width="150">
                  <template slot-scope="scope">
                    {{ scope.row.cashin | roundNum }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="commissionRate"
                  :label="$t('bonus.cr')"
                  sortable
                  width="100">
                  <template slot-scope="scope">
                    {{ scope.row.commissionRate * 100.0 | roundNum }}%
                  </template>
                </el-table-column>
                <el-table-column
                  prop="bonus"
                  :label="$t('bonus.bonus')"
                  sortable
                  width="120">
                  <template slot-scope="scope">
                    {{ scope.row.bonus | roundNum }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="debt"
                  :label="$t('bonus.debt')"
                  sortable
                  width="120">
                  <template slot-scope="scope">
                    {{ scope.row.debt | roundNum }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
<script>
import moment from 'moment'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  name: 'BonusForecast',
  data: function() {
  return {
    bonus: null,
    dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')]
  }
  },
  computed: {
    teamFilter: function() {
      let f = []
      for (let i = 0; i < this.team.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.team[i]['c_name'] : this.team[i]['e_name'],
          value = this.team[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    }
  },
  watch: {
    dateRange: function(val) {
      this.loadData()
    }
  },
  methods: {
    filterHandler(value, row, column) {
      //console.log(value)
      const property = column['property']
      //console.log(row[property])
      return row[property] === value
    },
    getSummaries: function(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = this.$t('reimbursement.sum')
          return
        }
        const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (sums[index] != 0)
              sums[index] = sums[index].toFixed(2)
            else
              sums[index] = '';
          } else {
            sums[index] = ''
          }
        })
        return sums;
    },
    exportExcel () {
    let wb = XLSX.utils.table_to_book(document.querySelector('#bonus-forecast'))
    /* get binary string as output */
    let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    try {
      FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-BonusForecast-' + this.dateRange[0] + ' to ' + this.dateRange[1] + '.xlsx')
    } catch (e) {
      if (typeof console !== 'undefined')
        console.log(e, wbout)
    }
    return wbout
    },
    loadData: function() {
      let that = this,
          startDate = this.dateRange[0],
          endDate = this.dateRange[1],
          query = '?userId=' + localStorage.getItem('token') + '&startDate=' + startDate + '&endDate=' + endDate
    this.$http.get(this.API3_PREFIX + 'bonus' + query).then(function (response) {
    that.bonus = response.data
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>